export default __webpack_public_path__ + "static/wunschpiercing-2-a10c63e47444ef21cc42aa0b7b9f5bae.jpg";